import {
  ArrowRightOutlined,
  InstagramOutlined,
  MailOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import type { ReactNode } from 'react';
import { Logotipo } from '@titularis/ui';
import { destinos } from '../destinos';

export function Fechamento() {
  return (
    <>
      <section className="fechamento">
        <div className="landing-secao">
          <span className="sobretitulo">COMECE PELO ENAC</span>
          <h2>
            Teste a <em>Titularis</em> e veja seu estudo <em>para Cartórios</em> subir de nível.
          </h2>
          <p>
            Crie sua conta, escolha uma disciplina e resolva suas primeiras questões comentadas.
          </p>
          <Button
            type="primary"
            size="large"
            href={destinos.criarConta}
            icon={<ArrowRightOutlined />}
            iconPlacement="end"
          >
            Criar conta grátis
          </Button>
          <small>Cadastro gratuito. Sem cartão de crédito.</small>
        </div>
      </section>
      <footer className="site-rodape">
        <div className="rodape-grade">
          <div className="rodape-marca">
            <Logotipo altura={27} />
            <p>
              Questões e legislação comentadas
              <br />
              para o Enac e concursos de cartórios.
            </p>
          </div>
          <Coluna
            titulo="Plataforma"
            links={[
              { rotulo: 'Como funciona', href: '/#como-funciona' },
              { rotulo: 'Módulos', href: '/#modulos' },
              { rotulo: 'Criar conta', href: destinos.criarConta },
              { rotulo: 'Entrar', href: destinos.entrar },
            ]}
          />
          <Coluna
            titulo="Explore"
            links={[
              { rotulo: 'Provas grátis', href: '/provas' },
              { rotulo: 'Notícias', href: '/noticias' },
              { rotulo: 'Revista', href: '/revista' },
              { rotulo: 'Materiais grátis', href: '/materiais' },
              { rotulo: 'Dúvidas', href: '/#duvidas' },
            ]}
          />
          <Coluna
            titulo="Converse com a gente"
            links={[
              {
                rotulo: 'titularis.com.br@gmail.com',
                href: 'mailto:titularis.com.br@gmail.com',
                icone: <MailOutlined />,
              },
              {
                rotulo: '@titularis.com.br',
                href: 'https://instagram.com/titularis.com.br',
                externo: true,
                icone: <InstagramOutlined />,
              },
              {
                rotulo: '+55 11 97072-6851',
                href: 'https://wa.me/5511970726851',
                externo: true,
                icone: <PhoneOutlined />,
              },
            ]}
          />
        </div>
        <div className="rodape-base">
          <span>© {new Date().getFullYear()} Titularis</span>
          <div>
            <a href="/termos">Termos de Uso</a>
            <a href="/privacidade">Política de Privacidade</a>
          </div>
        </div>
      </footer>
    </>
  );
}

function Coluna({
  titulo,
  links,
}: {
  titulo: string;
  links: { rotulo: string; href: string; externo?: boolean; icone?: ReactNode }[];
}) {
  return (
    <div className="rodape-coluna">
      <h3>{titulo}</h3>
      {links.map((link) => (
        <a
          key={link.rotulo}
          href={link.href}
          {...(link.externo ? { target: '_blank', rel: 'noreferrer noopener' } : {})}
        >
          {link.icone}
          {link.rotulo}
        </a>
      ))}
    </div>
  );
}
